export const audio = {
  "click": "https://dkmwdxc6g4lk7.cloudfront.net/assets/audio/click.mp3",
  "complete": "https://dkmwdxc6g4lk7.cloudfront.net/assets/audio/complete.mp3",
  "incomplete": "https://dkmwdxc6g4lk7.cloudfront.net/assets/audio/incomplete.mp3",
  "index": "https://dkmwdxc6g4lk7.cloudfront.net/assets/audio/index.js",
  "notification": "https://dkmwdxc6g4lk7.cloudfront.net/assets/audio/notification.mp3",
  "ping": "https://dkmwdxc6g4lk7.cloudfront.net/assets/audio/ping.wav"
}